import { render } from "./TarifasPage.vue?vue&type=template&id=4f148915"
import script from "./TarifasPage.vue?vue&type=script&lang=js"
export * from "./TarifasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__